import React from 'react';
import PickemButton from './PickemButton';
import moment from 'moment';

const GeneralSubmitView = props => {
  {
    {
      /**If it is first chapter then don't show previous button only show next button*/
    }
    if(props.current_chapter == 1 && props.chapters[2]){
      if(moment().isBefore(props.chapters[2].chapter_start_date)){
        return (
          <PickemButton
          {...props}
          disabled={!props.chapter.active}
          type={'submittingIndividualChapter'}
          button_name="Submit"
          />
        )
      }
    }
    // If next chapter is NOT active, submit at current chapter
    if(props.current_chapter && props.chapters){
      const next_chapter = props.chapters[props.current_chapter + 1];
      if(next_chapter && !next_chapter.active){
        return (
          <PickemButton
            {...props}
            disabled={!props.chapter.active}
            type={'submittingIndividualChapter'}
            button_name="Submit"
          />
        )
      }
    }
    if(props.next_is_empty)
      return (
        <PickemButton
          {...props}
          disabled={!props.chapter.active}
          type={'submittingIndividualChapter'}
          button_name="Submit"
        />
      )
    return props.current_chapter == 1 && props.chapter.next_button ? (
      <PickemButton {...props} button_name="Next" addOrSubtractNumber={-1} />
    ) : props.current_chapter > 1 && props.chapter.next_button ? (
      <div>
        {!props.mobile ?
        <PickemButton
          {...props}
          button_name="Previous"
          addOrSubtractNumber={1}
        /> : <></>}

        <PickemButton {...props} button_name="Next" addOrSubtractNumber={-1} />
      </div>
    ) : props.game.number_of_quarters == props.current_chapter &&
      props.game.number_of_quarters > 1 &&
      props.chapters[props.current_chapter - 1].next_button ? (
      <div>
        <PickemButton
          {...props}
          button_name="Previous"
          addOrSubtractNumber={1}
        />

        <PickemButton
          {...props}
          type={'submittingEntireSeries'}
          button_name="Submit"
        />
      </div>
    ) : (
      <PickemButton
        {...props}
        disabled={!props.chapter.active}
        type={'submittingIndividualChapter'}
        button_name="Submit"
      />
    );
  }
};

export default GeneralSubmitView;
